import { create } from "zustand";
import { persist } from "zustand/middleware";

// types
import { Filters } from "types/filters-store.types";
import { FilterKeys } from "constants/filters";

// utils
import { getFilterCount } from "utils/advanced-search";

// constants
import {
  LastUpdatedList,
  OperatorType,
  RelationOperatorType,
} from "constants/filters";

const initialState: Filters = {
  searchProfiles: {
    searchTerm: "",
  },
  location: {
    states: [],
    zipCodes: [],
    counties: [],
    districts: [],
    msas: [],
  },
  sbaCertifications: {
    activeCerts: [],
    isPreviousCert: false,
    operatorType: OperatorType.OR,
  },
  naics: {
    codes: [],
    isPrimary: false,
    operatorType: OperatorType.OR,
  },
  selfCertifications: {
    certifications: [],
    operatorType: OperatorType.OR,
  },
  keywords: {
    list: [],
    operatorType: OperatorType.OR,
  },
  lastUpdated: {
    date: LastUpdatedList[0],
  },
  samStatus: {
    isActiveSAM: false,
  },
  qualityAssuranceStandards: {
    qas: [],
  },
  bondingLevels: {
    constructionIndividual: "",
    constructionAggregate: "",
    serviceIndividual: "",
    serviceAggregate: "",
  },
  businessSize: {
    relationOperator: RelationOperatorType.AT_LEAST,
    numberOfEmployees: "",
  },
  annualRevenue: {
    relationOperator: RelationOperatorType.AT_LEAST,
    annualGrossRevenue: "",
  },
  entityDetailId: "",
};

type FiltersStore = {
  filters: Filters;
  lastSentFilters: Filters | null;

  setFilter: <T extends keyof Filters>(
    filterType: T,
    filterItems: Filters[T]
  ) => void;

  areFiltersApplied: () => boolean;

  setLastSentFilters: (filters: Filters | null) => void; // Add setter for lastSentFilters;

  clearFilters: () => void;
};

const useFiltersStore = create(
  persist<FiltersStore>(
    (set, get) => ({
      filters: initialState,
      lastSentFilters: null,
      currentPage: 1,

      setFilter: (filterType, filterItems) => {
        if (filterType !== FilterKeys.ENTITY_DETAIL_ID) { // remove filter applied from homepage search bar
          set((state) => ({
            filters: {
              ...state.filters,
              [filterType]: filterItems,
              [FilterKeys.ENTITY_DETAIL_ID]: "",
            }
          }))
        } else 
        set((state) => ({
          filters: {
            ...state.filters,
            [filterType]: filterItems,
          }
        }))
      },

      clearFilters: () =>
        set((_prevValue) => ({
          filters: initialState
        })),

      areFiltersApplied: () => {
        const filters = get().filters;
        return Object.keys(filters).some((filterType) => {
          return getFilterCount(filters, filterType) > 0;
        });
      },

      setLastSentFilters: (filters) =>
        set((state) => ({
          ...state,
          lastSentFilters: filters,
        })),
    }),
    {
      name: "filters-store-v1.67",
    }
  )
);
export default useFiltersStore;
